import React, { useContext, useEffect, useState } from 'react';

//styles
import styles from './DetailLanding.module.scss';

//contexts
import { myUserDataContext } from '../../../App';

//dependency
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import axios from 'axios';

//component
import Loading from '../../../shared/Loading';

//functions
import { convertToPersianDate } from '../../../functions/convertToPersianDate';
import { responseHandler } from '../../../functions/responseHandler';
import { notify } from '../../../functions/toasts';
import moment from 'jalali-moment';

const DetailLanding = () => {
  const params = useParams();
  const navigate = useNavigate();

  const convertToShamsiDateTime = (gregorianDateTime) => {
    if (!gregorianDateTime) return '-';

    const m = moment(gregorianDateTime, 'YYYY-MM-DD HH:mm:ss');
    const shamsiDate = m.format('jYYYY/jMM/jDD');
    const time = m.format('HH:mm:ss');

    return `${shamsiDate} ${time}`;
  };

  const [checkBtnDownload, setCheckBtnDownload] = useState(false);

  const data = useContext(myUserDataContext);
  const { userData, isLogin, mainUrl } = data;
  const { token } = userData;

  const [detailLanding, setDetailLanding] = useState({});
  const [metaFixData, setMetaFixData] = useState({});

  const [onlineUser, setOnlineUser] = useState('');
  const [isLoad, setIsLoad] = useState(true);
  const [meta, setMeta] = useState(null);
  const [oldMeta, setOldMeta] = useState(null);
  const [averageCtrByPriority, setAverageCtrByPriority] = useState(
    {}
  );
  const [sumLeadAndViewByPriority, setSumLeadAndViewByPriority] =
    useState({});

  const [checkLoadingDataPlusBtn, setCheckLoadingDataPlusBtn] =
    useState(false);
  const [campaignData, setCampaignData] = useState(null);
  const [metaFixTime, setMetaFixTime] = useState(null);

  const getOnline = async (id) => {
    try {
      const res = await axios.get(
        `/statistic/online-client-number/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status) {
        setOnlineUser(res.data.data);
      }
    } catch (error) {
      responseHandler(error, 'error');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoad(true);

      try {
        const res = await axios.get(
          `/landing/show/${params.id}?relations[]=template&relations[]=user&relations[]=groups&relations[]=parameterGroup.variants&relations[]=parameterGroup.activities`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        responseHandler(res, 'succ', false);
        if (res.data.status) {
          setDetailLanding(res.data.data);
          setIsLoad(false);
          await getOnline(res.data.data.id);
        }
      } catch (error) {
        responseHandler(error, 'error');
        if (error.response?.status === 404)
          navigate('/notfound', { replace: true });
      } finally {
        setIsLoad(false);
      }
    };

    fetchData();
  }, []);

  //for download excel handler
  const downloadHandler = () => {
    setCheckBtnDownload(true);
    axios({
      url: `/landing-extra/excel-download/${params.id}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    })
      .then((res) => {
        if (res && res.data instanceof Blob) {
          const url = window.URL.createObjectURL(
            new Blob([res.data])
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `${detailLanding.title}.xlsx`
          ); // نام دلخواه برای فایل با پسوند Excel

          document.body.appendChild(link);
          link.click();
          link.remove();
          setCheckBtnDownload(false);
        } else {
          console.log(res);
          notify('خطا در دریافت فایل اکسل', 'error');
          setCheckBtnDownload(false);
        }
      })
      .catch((error) => {
        console.log(error);
        notify('خطا در دریافت فایل اکسل', 'error');
        setCheckBtnDownload(false);
      });
  };

  const downloadParamsHandler = () => {
    setCheckBtnDownload(true);
    axios({
      url: `/landing-extra/excel-download-by-variant/${params.id}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    })
      .then((res) => {
        if (res && res.data instanceof Blob) {
          const url = window.URL.createObjectURL(
            new Blob([res.data])
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `${detailLanding.title}.xlsx`
          ); // نام دلخواه برای فایل با پسوند Excel

          document.body.appendChild(link);
          link.click();
          link.remove();
          setCheckBtnDownload(false);
        } else {
          console.log(res);
          notify('خطا در دریافت فایل اکسل', 'error');
          setCheckBtnDownload(false);
        }
      })
      .catch((error) => {
        console.log(error);
        notify('خطا در دریافت فایل اکسل', 'error');
        setCheckBtnDownload(false);
      });
  };

  //for plus data btn
  const plusDataHandler = () => {
    setCheckLoadingDataPlusBtn(true);

    const data = JSON.parse(detailLanding.parameters);
    const body = {
      token: data.token,
      type: data.type,
    };

    axios
      .post('/landing/get-campaign-by-token', body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setCampaignData(res.data.data);
          setCheckLoadingDataPlusBtn(false);
        } else {
          notify('اطلاعات یافت نشد', 'error');
          console.log(res);
          setCheckLoadingDataPlusBtn(false);
        }
      })
      .catch((error) => {
        responseHandler(error, 'error');
        setCheckLoadingDataPlusBtn(false);
      });
  };

  //for ctr groups
  const [showCtrGroups, setShowCtrGroups] = useState(false);
  const [showMetaFixData, setShowMetaFixData] = useState(false);

  //for get ctr details
  const [showTableCTR, setShowTableCTR] = useState(false);
  const [isloadTableCTR, setIsLoadTableCTR] = useState(true);
  const [dataTableCTR, setDataTableCTR] = useState([]);

  const getCTRDetails = () => {
    setShowTableCTR(true);
    setIsLoadTableCTR(true);
    setShowCtrGroups(false);

    axios
      .get(`/landing/ctr-log/${detailLanding.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setDataTableCTR(res.data.data);
          setIsLoadTableCTR(false);
        } else {
          notify('اطلاعات یافت نشد', 'error');
          console.log(res);
          setShowTableCTR(false);
        }
      })
      .catch((error) => {
        notify('مشکل در دریافت', 'error');
        console.log(error);
        setShowTableCTR(false);
      });
  };

  const {
    id,
    title,
    slug,
    user,
    template,
    statistics_count,
    created_at,
    updated_at,
  } = detailLanding;

  if (!isLoad) {
    //cal date and time create
    const dateAndTimeCreate = created_at;
    const splitDataAndTimeCreate = dateAndTimeCreate?.split(' ');
    var dateCreate = convertToPersianDate(
      splitDataAndTimeCreate?.[0]
    );
    var timeCreate = splitDataAndTimeCreate?.[1];

    //cal date and time Update
    const dateAndTimeUpdate = updated_at;
    const splitDataAndTimeUpdate = dateAndTimeUpdate?.split(' ');
    var dateUpdate = convertToPersianDate(
      splitDataAndTimeUpdate?.[0]
    );
    var timeUpdate = splitDataAndTimeUpdate?.[1];
  }

  useEffect(() => {
    if (detailLanding?.parameter_group?.meta) {
      const Meta = JSON.parse(detailLanding.parameter_group.meta);
      setMeta(Meta);
    }
  }, [detailLanding?.parameter_group]);

  // محاسبه میانگین CTR
  useEffect(() => {
    if (!meta || meta.length === 0) return;

    const grouped = {};

    meta.forEach((item) => {
      if (
        item.ctr_result != null &&
        item.from_variant != null &&
        item.from_variant !== 0
      ) {
        const key = item.from_variant;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(item.ctr_result);
      }
    });

    const averages = {};
    Object.entries(grouped).forEach(([key, values]) => {
      const avg =
        values.reduce((sum, val) => sum + val, 0) / values.length;
      averages[key] = avg.toFixed(2);
    });

    setAverageCtrByPriority(averages);
  }, [meta]);

  // محاسبه جمع lead_count و view_count
  useEffect(() => {
    if (!meta || meta.length === 0) return;

    const grouped = {};

    meta.forEach((item) => {
      if (item.from_variant != null && item.from_variant !== 0) {
        const key = item.from_variant;
        if (!grouped[key]) {
          grouped[key] = { lead: 0, view: 0 };
        }

        grouped[key].lead += item.lead_count || 0;
        grouped[key].view += item.view_count || 0;
      }
    });

    setSumLeadAndViewByPriority(grouped);
  }, [meta]);

  useEffect(() => {
    if (
      detailLanding?.parameter_group &&
      meta &&
      detailLanding?.parameter_group?.is_fixed
    ) {
      const metaLast = meta[meta?.length - 1];

      setMetaFixTime(metaLast.start_at);
    }
  }, [meta, detailLanding]);

  const getMetaData = () => {
    axios
      .get(
        `/landing/get-ctr-by-date/${detailLanding?.slug}?start_at=${metaFixTime}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setMetaFixData(res.data.data);
          setShowMetaFixData(true);
        } else {
          notify('اطلاعات یافت نشد', 'error');
          console.log(res);
        }
      })
      .catch((error) => {
        notify('مشکل در دریافت', 'error');
      });
  };

  useEffect(() => {
    if (detailLanding?.parameter_group?.activities?.length > 0) {
      const extractedMeta = detailLanding?.parameter_group?.activities
        ?.map((activity) => {
          try {
            const metaString = activity.properties?.model_meta?.meta;
            const parsedMeta = JSON.parse(metaString);
            return parsedMeta;
          } catch (error) {
            console.error('Error parsing meta JSON:', error);
            return null;
          }
        })
        .filter(Boolean);

      setOldMeta(extractedMeta);
    }
  }, [detailLanding]);

  return !isLoad && isLogin ? (
    <>
      <div className={styles.DetailLandingDiv}>
        <div className={styles.infoTop}>
          <div className={styles.iconDiv}>
            <i className="bi bi-file-earmark"></i>
          </div>

          <div className={styles.textsInfo}>
            <span className={styles.title}>{title}</span>
            <span className={styles.slug}>
              {`آدرس: `}
              <Link to={`${mainUrl}${slug}`} target="_blank">
                {slug}
              </Link>
            </span>
          </div>
        </div>

        <div className={styles.iconDown}>
          <i className="bi bi-caret-down-fill"></i>
        </div>

        <div className={styles.btnPlus}>
          <button
            className="btn btn-secondary btn-sm"
            disabled={checkLoadingDataPlusBtn}
            onClick={plusDataHandler}
          >
            اطلاعات بیشتر +
          </button>
          <button
            className="btn btn-sm btn-warning me-2"
            onClick={getCTRDetails}
          >
            محاسبه دقیق CTR
          </button>
          <button
            className="btn btn-sm btn-success me-2"
            onClick={() => {
              setShowCtrGroups(!showCtrGroups);
              setShowTableCTR(false);
            }}
          >
            زیرمجموعه ها CTR
          </button>
          <Link to={`/dashboard/showLandings/logs/${id}`}>
            <button className="btn btn-sm btn-primary me-2">
              لاگ تغییرات
            </button>
          </Link>
        </div>

        <div className={styles.infoCenter}>
          <div className={`${styles.cardLanding} ${styles.card1}`}>
            <div>
              <Link to={`/dashboard/visits?landing_id=${params.id}`}>
                <span
                  className={`${styles.tedadBzdid} ${
                    campaignData !== null &&
                    styles.styleWhenClickBtnDataPlus
                  }`}
                >
                  {statistics_count}
                </span>
              </Link>
              <span className={styles.labels}>بازدید</span>
            </div>

            {campaignData !== null && (
              <>
                <div>
                  <span
                    className={`${styles.tedadBzdid} ${styles.styleWhenClickBtnDataPlus}`}
                  >
                    {campaignData.total_entries}
                  </span>
                  <span className={styles.labels}>تعداد شماره</span>
                </div>

                <div>
                  <span
                    className={`${styles.tedadBzdid} ${styles.styleWhenClickBtnDataPlus}`}
                  >
                    {(
                      (campaignData.total_entries /
                        Number(statistics_count)) *
                      100
                    ).toFixed(2) + '%'}
                  </span>
                  <span className={styles.labels}>CTR</span>
                </div>
              </>
            )}

            {checkLoadingDataPlusBtn && (
              <div className={styles.divSnipper}>
                <div
                  className="spinner-border text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </div>

          <div className={`${styles.cardLanding} ${styles.card2}`}>
            <div className={styles.nameTitle}>
              <span>
                سازنده:{' '}
                {`${user?.first_name ?? 'حذف شده'} ${
                  user?.last_name ?? 'حذف شده'
                }`}
              </span>
              <span>قالب: {`${template?.title ?? 'حذف شده'}`}</span>
            </div>

            <div className={styles.createUpdate}>
              <span>ایجاد: {`${dateCreate} ${timeCreate}`}</span>
              <span>آپدیت: {`${dateUpdate} ${timeUpdate}`}</span>
            </div>
          </div>

          <div className={`${styles.cardLanding} ${styles.card3}`}>
            <div className={styles.onlineDiv}>
              <span className={styles.glow}>{onlineUser}</span>
            </div>

            <span>آنلاین</span>
          </div>
        </div>

        {showTableCTR ? (
          <div className={`${styles.tableCTR} mx-3`}>
            <div
              className="accordion"
              id="accordionPanelsStayOpenExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    جزئیات CTR
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body">
                    {isloadTableCTR ? (
                      <Loading
                        color="#ffc107"
                        height="100px"
                        text={false}
                      />
                    ) : dataTableCTR.length ? (
                      <div className="table-responsive">
                        <table className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden">
                          <thead>
                            <tr>
                              <th scope="col">ردیف</th>
                              <th scope="col">بازدید</th>
                              <th scope="col">شماره</th>
                              <th scope="col">CTR</th>
                              <th scope="col">تاریخ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataTableCTR.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <th scope="row">{item.title}</th>
                                  <td>{item.view}</td>
                                  <td>{item.count}</td>
                                  <td>{item.ctr}</td>
                                  <td>{item.created_at}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div
                        className="alert alert-warning d-flex align-items-center"
                        role="alert"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5rem"
                          height="1.5rem"
                          className="ms-2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M9.73 3.993a2.749 2.749 0 0 1 4.54 0l.432.632a75.95 75.95 0 0 1 6.944 12.563l.09.208a2.511 2.511 0 0 1-2.024 3.497a69.412 69.412 0 0 1-15.424 0a2.511 2.511 0 0 1-2.024-3.497l.09-.208A75.95 75.95 0 0 1 9.298 4.625zM13 9a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-1 2.75a.75.75 0 0 1 .75.75v5a.75.75 0 1 1-1.5 0v-5a.75.75 0 0 1 .75-.75"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div>اطلاعاتی یافت نشد</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : showCtrGroups ? (
          <div className={`${styles.tableCTR} mx-3`}>
            <div
              className="accordion"
              id="accordionPanelsStayOpenExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    زیرمجموعه ها CTR
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  className="accordion-collapse collapse show"
                >
                  <div className="accordion-body">
                    <div className="table-responsive">
                      {detailLanding?.landing_group?.[0]
                        ?.CTR_target && (
                        <p
                          style={{ color: 'red', margin: 10 }}
                        >{`CTR-TARGET لندینگ: ${detailLanding?.landing_group?.[0]?.CTR_target}`}</p>
                      )}

                      {detailLanding?.landing_group?.[0] && (
                        <p
                          style={{ color: 'red', margin: 10 }}
                        >{`فیکس شدن لندینگ: ${
                          detailLanding?.landing_group?.[0]
                            ?.is_fixed === 1 ||
                          detailLanding?.landing_group?.[0]
                            ?.is_fixed === true
                            ? 'بله'
                            : 'خیر'
                        }`}</p>
                      )}

                      {detailLanding?.parameter_group?.CTR_target && (
                        <p
                          style={{ color: 'red', margin: 10 }}
                        >{`CTR-TARGET پارامتر: ${detailLanding?.parameter_group?.CTR_target}`}</p>
                      )}

                      {detailLanding?.parameter_group && (
                        <p
                          style={{ color: 'red', margin: 10 }}
                        >{`فیکس شدن پارامتر: ${
                          detailLanding?.parameter_group?.is_fixed ===
                            1 ||
                          detailLanding?.parameter_group?.is_fixed ===
                            true
                            ? 'بله'
                            : 'خیر'
                        }`}</p>
                      )}

                      {detailLanding?.landing_group?.[0] && (
                        <>
                          <h2 style={{ marginTop: 40 }}>لندینگ ها</h2>

                          <table
                            style={{
                              textAlign: 'center',
                              marginTop: 40,
                            }}
                            className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden"
                          >
                            <thead>
                              <tr>
                                <th scope="col">لندینگ</th>
                                <th scope="col">وضعیت</th>
                                <th scope="col">الویت</th>
                                <th scope="col">CTR</th>
                                <th scope="col">براساس مدت زمان</th>
                                <th scope="col">
                                  براساس تعداد بازدید
                                </th>
                                <th scope="col">فیکس شده</th>
                                <th scope="col">تعداد بازدید</th>
                                <th scope="col"> شماره ورودی</th>
                              </tr>
                            </thead>
                            <tbody>
                              {detailLanding?.landing_group?.[0]?.groups?.map(
                                (item, index) => {
                                  return (
                                    <tr key={index}>
                                      <th scope="row">
                                        <Link
                                          style={{ color: '#4ED7F1' }}
                                          to={`${mainUrl}${slug}`}
                                          target="_blank"
                                        >
                                          {item.landing_id}
                                        </Link>
                                      </th>
                                      <td>
                                        {item.is_active === 1 ||
                                        item.is_active === true
                                          ? 'فعال'
                                          : 'غیرفعال'}
                                      </td>
                                      <td>{item.priority}</td>
                                      <td>{item.CTR_result}</td>
                                      <td>
                                        {item.time_change
                                          ? `${item.time_change} دقیقه`
                                          : '-'}
                                      </td>
                                      <td>
                                        {item.view
                                          ? item.view_change
                                          : '-'}
                                      </td>
                                      <td>
                                        {item.is_fixed === 1 ||
                                        item.is_fixed === true
                                          ? 'بله'
                                          : 'خیر'}
                                      </td>
                                      <td>{item.view_count}</td>
                                      <td>{item.lead_count}</td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </>
                      )}

                      {detailLanding?.parameter_group && (
                        <>
                          <h2 style={{ marginTop: 40 }}>پارامترها</h2>
                          <table
                            style={{
                              textAlign: 'center',
                              marginTop: 40,
                            }}
                            className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden"
                          >
                            <thead>
                              <tr>
                                <th scope="col">وضعیت</th>
                                <th scope="col">الویت</th>
                                {/* <th scope="col">CTR آخرین</th> */}
                                <th scope="col">براساس مدت زمان</th>
                                <th scope="col">
                                  براساس تعداد بازدید
                                </th>
                                <th scope="col">میانگین CTR</th>{' '}
                                {/* ستون جدید */}
                                <th scope="col">
                                  جمع شماره ورودی
                                </th>{' '}
                                {/* ستون جدید */}
                                <th scope="col">جمع بازدید</th>{' '}
                              </tr>
                            </thead>
                            <tbody>
                              {detailLanding?.parameter_group?.variants?.map(
                                (item, index) => {
                                  const avgCtr =
                                    averageCtrByPriority[
                                      item.priority
                                    ];
                                  const sum =
                                    sumLeadAndViewByPriority[
                                      item.priority
                                    ] || { lead: '-', view: '-' };

                                  return (
                                    <tr key={index}>
                                      <td>
                                        {item.is_active === 1 ||
                                        item.is_active === true
                                          ? 'فعال'
                                          : 'غیرفعال'}
                                      </td>
                                      <td>{item.priority}</td>
                                      {/* <td>{item.CTR_result}</td> */}
                                      {/* <td>
                                        {item.CTR_result ?? '-'}
                                      </td> */}
                                      <td>
                                        {item.time_change
                                          ? `${item.time_change} دقیقه`
                                          : '-'}
                                      </td>
                                      <td>
                                        {item.view_change
                                          ? item.view_change
                                          : '-'}
                                      </td>
                                      <td>
                                        {avgCtr !== undefined
                                          ? avgCtr
                                          : '-'}
                                      </td>
                                      <td>{sum.lead}</td>{' '}
                                      {/* جمع lead_count */}
                                      <td>{sum.view}</td>
                                    </tr>
                                  );
                                }
                              )}
                              <tr>
                                <td>مجموع</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                  {detailLanding?.parameter_group?.variants
                                    ?.reduce((acc, item) => {
                                      const avgCtr =
                                        averageCtrByPriority[
                                          item.priority
                                        ];
                                      return (
                                        acc +
                                        (parseFloat(avgCtr) || 0)
                                      );
                                    }, 0)
                                    .toFixed(2) /
                                    detailLanding?.parameter_group?.variants?.map(
                                      (item) => {
                                        const avgCtr =
                                          averageCtrByPriority[
                                            item.priority
                                          ];
                                        return avgCtr;
                                      },
                                      0
                                    ).length}
                                </td>
                                <td>
                                  {detailLanding?.parameter_group?.variants?.reduce(
                                    (acc, item) => {
                                      const sum =
                                        sumLeadAndViewByPriority[
                                          item.priority
                                        ] || { lead: 0, view: 0 };
                                      return acc + (sum.lead || 0);
                                    },
                                    0
                                  )}
                                </td>
                                <td>
                                  {detailLanding?.parameter_group?.variants?.reduce(
                                    (acc, item) => {
                                      const sum =
                                        sumLeadAndViewByPriority[
                                          item.priority
                                        ] || { lead: 0, view: 0 };
                                      return acc + (sum.view || 0);
                                    },
                                    0
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          {detailLanding?.parameter_group?.meta && (
                            <>
                              <h2 style={{ marginTop: 40 }}>
                                تغییرات پارامترها
                              </h2>
                              <table
                                style={{
                                  textAlign: 'center',
                                  marginTop: 40,
                                }}
                                className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden"
                              >
                                <thead>
                                  <tr>
                                    <th scope="col">شروع</th>
                                    <th scope="col">پایان</th>
                                    <th scope="col">
                                      CTR(هنگام شروع)
                                    </th>
                                    <th scope="col"> پارامتر</th>
                                    {/* <th scope="col">به پارامتر</th> */}
                                    {/* <th scope="col">تعداد بازدید</th> */}
                                    {/* <th scope="col">
                                      شماره ورودی (هنگام شروع)
                                    </th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {meta?.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          {convertToShamsiDateTime(
                                            item?.start_at
                                          ) ?? '-'}
                                        </td>
                                        <td>
                                          {convertToShamsiDateTime(
                                            item?.end_at
                                          ) ?? '-'}
                                        </td>
                                        <td>
                                          {item.ctr_result ?? '-'}
                                        </td>
                                        <td>
                                          {item.from_variant ?? '-'}
                                        </td>
                                        {/* <td>
                                          {item.to_variant ?? '-'}
                                        </td>
                                        <td>
                                          {item.view_count ?? '-'}
                                        </td>
                                        <td>
                                          {item.lead_count ?? '-'}
                                        </td> */}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>

                              <button
                                className="btn btn-success me-2"
                                style={{ color: '#fff' }}
                                onClick={downloadParamsHandler}
                                disabled={checkBtnDownload}
                              >
                                {`دانلود اکسل تغییرات`}
                                {checkBtnDownload ? (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  <i className="bi bi-file-spreadsheet-fill me-2"></i>
                                )}
                              </button>
                              {metaFixTime && (
                                <>
                                  <button
                                    className="btn btn-warning me-2"
                                    style={{ color: '#fff' }}
                                    onClick={getMetaData}
                                  >
                                    {`اطلاعات پارامتر فیکس شده`}
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {showMetaFixData && (
          <>
            <h3
              style={{ margin: 30 }}
            >{`اطلاعات پارامتر فیکس شده`}</h3>
            <table
              style={{
                textAlign: 'center',
                marginTop: 40,
              }}
              className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden"
            >
              <thead>
                <tr>
                  <th scope="col">CTR</th>
                  <th scope="col">تعداد بازدید</th>
                  <th scope="col"> شماره ورودی</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{metaFixData.ctr_result}</td>
                  <td>{metaFixData.view_count}</td>
                  <td>{metaFixData.lead_count}</td>
                </tr>
              </tbody>
            </table>
          </>
        )}

        {oldMeta && showCtrGroups && (
          <div>
            {oldMeta?.map((old) => {
              return (
                <>
                  <h2 style={{ marginTop: 40 }}>
                    تغییرات پارامترهای قبلی
                  </h2>
                  <table
                    style={{
                      textAlign: 'center',
                      marginTop: 40,
                    }}
                    className="table table-dark table-striped table-hover table-sm rounded-2 overflow-hidden"
                  >
                    <thead>
                      <tr>
                        <th scope="col">شروع</th>
                        <th scope="col">پایان</th>
                        <th scope="col">CTR(هنگام شروع)</th>
                        <th scope="col"> پارامتر</th>
                      </tr>
                    </thead>
                    <tbody>
                      {old?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {convertToShamsiDateTime(
                                item?.start_at
                              ) ?? '-'}
                            </td>
                            <td>
                              {convertToShamsiDateTime(
                                item?.end_at
                              ) ?? '-'}
                            </td>
                            <td>{item.ctr_result ?? '-'}</td>
                            <td>{item.from_variant ?? '-'}</td>
                            {/* <td>
                                              {item.to_variant ?? '-'}
                                            </td>
                                            <td>
                                              {item.view_count ?? '-'}
                                            </td>
                                            <td>
                                              {item.lead_count ?? '-'}
                                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {metaFixTime && (
                    <>
                      <button
                        className="btn btn-warning me-2"
                        style={{ color: '#fff' }}
                        onClick={getMetaData}
                      >
                        {`اطلاعات پارامتر فیکس شده`}
                      </button>
                    </>
                  )}
                </>
              );
            })}
          </div>
        )}

        <div className={styles.btns}>
          <button
            className="btn btn-primary"
            onClick={() => navigate(-1)}
          >{`بازگشت`}</button>
          <button
            className="btn btn-success me-2"
            style={{ color: '#fff' }}
            onClick={downloadHandler}
            disabled={checkBtnDownload}
          >
            {`دانلود اکسل`}
            {checkBtnDownload ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <i className="bi bi-file-spreadsheet-fill me-2"></i>
            )}
          </button>
        </div>
      </div>
    </>
  ) : (
    <Loading color="#7545fb" />
  );
};

export default DetailLanding;
